import React from 'react';
interface MarqueeProps {
  children: React.ReactNode;
  className?: string;
}
export function Marquee({
  children,
  className = ''
}: MarqueeProps) {
  return <div className={`overflow-hidden whitespace-nowrap w-full ${className}`} data-id="element-129">
      <div className="animate-marquee-content inline-block" data-id="element-130">{children}</div>
    </div>;
}